module.exports = __webpack_public_path__ + "static/media/logoFates.77687d5f.jpg";